import { render } from "./MultipleRadialbarChart.vue?vue&type=template&id=08c2328c"
import script from "./MultipleRadialbarChart.vue?vue&type=script&lang=js"
export * from "./MultipleRadialbarChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__